module.exports = __webpack_public_path__ + "img/product-delay-solve-bg-icon.00af4cda.png";